import type { EditorState } from '@/features/editor/stores/editor-store'
import type { KnowledgeKind } from '@/features/editor/types/knowledge.types'
import { digestEditor } from '@/features/editor/lib/editor-digest'
import { buildDigestInput } from '@/features/editor/lib/editor-digest-input'

function computeDigest(s: Pick<EditorState, 'draft' | 'knowledge'>) {
  // 只比较“会保存到后端的语义”
  return digestEditor(buildDigestInput(s.draft, s.knowledge))
}

export function selectIsDirty(s: EditorState): boolean {
  if (s.lastSavedDigest == null) return false
  return computeDigest(s) !== s.lastSavedDigest
}

/**
 * 已发布，但当前草稿尚未同步到线上（需要提交审核）
 */
export function selectIsLiveOutdated(s: EditorState): boolean {
  if (s.publishStatus !== 'published') return false
  if (s.lastPublishedDigest == null) return false
  return computeDigest(s) !== s.lastPublishedDigest
}

export function makeSelectKnowledgeCounts(kind: KnowledgeKind) {
  return (s: EditorState) => {
    const list = s.knowledge[kind]

    let enabled = 0
    for (const item of list) {
      if (item.enabled) enabled++
    }

    return {
      total: list.length,
      enabled,
    }
  }
}
